var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from '../baseApi';
export default class VendorsApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'vendors';
    }
    getVendors(params_1) {
        return __awaiter(this, arguments, void 0, function* (params, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}`, params }, options));
        });
    }
    getVendor(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'GET',
                route: `${this.apiBasePath}/${id}`,
            });
        });
    }
    getVendorKeys(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'GET',
                route: `${this.apiBasePath}/${id}/keys`,
            });
        });
    }
    createVendor(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}`,
                data,
            });
        });
    }
    updateVendor(id, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'PUT',
                route: `${this.apiBasePath}`,
                params: {
                    id: id,
                },
                data,
            });
        });
    }
    deleteVendor(id_1) {
        return __awaiter(this, arguments, void 0, function* (id, softDelete = true) {
            return yield this.apiCall({
                method: 'DELETE',
                route: `${this.apiBasePath}`,
                params: {
                    id: id,
                    softDelete: softDelete,
                },
            });
        });
    }
}
//# sourceMappingURL=index.js.map